module.exports = __webpack_public_path__ + "img/rsz_afcfta_number.1d3221ff.jpg";